import { Pipe, PipeTransform } from '@angular/core';
import { timeout } from 'q';
import { filter } from 'rxjs/operator/filter';

@Pipe({
  name: 'groupFilter'
})
export class GroupFilterPipe implements PipeTransform {

  checkEmpty(item) {
    if (item.toString().trim() === '') {
      return true;
    }
    return false;
  }

  transform(value, temp: any) {
    let args = temp.split('|');
    let hrStatus = args[0].split(',');
    let expertStatus = args[1].split(',');
    let issues = args[2].split(',');
    let hrName = args[3].split(',');
    if (this.checkEmpty(hrStatus) && this.checkEmpty(expertStatus) && this.checkEmpty(issues) && this.checkEmpty(hrName)) {
      return value;
    }

    return value.filter((item) => {
      return this.ifExist(hrStatus, item.statushradmin_desc) !== -1 &&
        this.ifExist(expertStatus, item.statusabsenceexpert_desc) !== -1 &&
        this.isInNames(hrName, item) &&
        this.getCommonIssues(issues, item.typesOfErrorOrIssue) > 0;
    });
  }

  isInNames(hrName, item) {
    return this.ifExist(hrName, item.hrname) !== -1 || this.ifExist(hrName, item.expertname) !== -1;
  }

  ifExist(args, item) {
    for (let i = 0; i < args.length; i++) {
      args[i] = args[i].trim();
    }
    if (item === null) {
      if (item.trim() === '') {
        return -1;
      }
    }
    if (this.checkEmpty(args)) {
      return 0;
    }
    return args.indexOf(item.trim());
  }

  getCommonIssues(args, issueTypes) {

    if (this.checkEmpty(args)) {
      return 1;
    }

    let res = issueTypes.filter((item) => {
      return args.indexOf(item) > -1;
    });
    return res.length;
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/group-filter.pipe.ts